import { Dialog, DialogProps } from "../../core/components/dialog.js";
import { FAIcon } from "../../core/components/faIcon.js";
import { TranslationTextBox, TranslationTextBoxProps } from "../../core/components/translationTextBox.js";
import { RightFloatingButtonScalor } from "../editor_common_components.js";
import { Button } from "../../core/components/button.js";
import { ComponentHelper } from "../../core/util/componentHelper.js";
import { Config } from "../../core/config/config.js";
import { TextBoxField } from "../../core/components/textBox.js";
import React from "react";
export class TranslatableTextEditor extends React.Component<{ onTextChange: any, value: any[], label: string, languageFieldName, translationFieldName }, { showDialog: boolean }>{
    constructor(props) {
        super(props);
        this.state = { showDialog: false };
    }

    handleFieldClicked = (field: { model: string }, value: any, dataItem?: any) => {
        this.props.onTextChange(value);
    }

    handleObjectChanged = (field: { model: string }, object: any) => {
        this.props.onTextChange(object.Id);
    }

    handleSave = (name) => {
        this.setState({ showDialog: false });
        this.props.onTextChange(name);
    }

    getTranslatedText = (): string => {

        if (this.props.value) {
            const result = this.props.value.filter(v => v[this.props.languageFieldName] == Config.user.languageId)

            if (result && result.length > 0) {
                return result[0][this.props.translationFieldName]
            }
        }

        return "";
    }

    render() {

        const dialog = this.state.showDialog ? <TranslatableTextDialog
            value={this.props.value}
            onClose={() => this.setState({ showDialog: false })}
            languageFieldName={this.props.languageFieldName}
            translationFieldName={this.props.translationFieldName}
            onSave={this.handleSave}></TranslatableTextDialog> : null;
        return (
            <li>
                {dialog}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="edit" title="Edit" handleClick={() => this.setState({ showDialog: true })}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        {this.getTranslatedText()}
                    </div>
                </div>
            </li>
        );
    }
};

export class TranslatableTextDialog extends React.Component<{ onSave, onClose, value, languageFieldName, translationFieldName }, { currentValue }>{

    private textArea: HTMLTextAreaElement;
    private _factory = ComponentHelper.createFactory();

    private dialogProps: DialogProps = {
        title: "Change translations",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    this.props.onClose();
                    return true;
                }
            },
            {
                label: "Save",
                action: () => {
                    this.props.onSave(this.isValid(this.state.currentValue) ? this.state.currentValue : this.initialValue)
                },
                primary: true
            }],
        afterClose: () => {
        },
        width: 500,
        open: true
    }

    private textBoxProps: TextBoxField = {
        type: "text",
        model: "",
        triggerOnChange: true
    }
    private initialValue;
    constructor(props) {
        super(props)
        this.initialValue = props.value;
        this.state = { currentValue: props.value };
    }

    handleChange = (field, value: string) => {

        this.setState({ currentValue: value });
    }

    isValid = (newValue) => {

        return true;
    }

    getInvalidIndicator = () => {
        return !this.isValid(this.state.currentValue) ? <div style={{
            marginTop: "5px",
            backgroundColor: "#f8e8e8",
            borderLeftColor: "red",
            borderLeftWidth: "4px",
            padding: "3px", borderLeftStyle: "solid",
            color: "#f05050",
            display: "flex"
        }}> <FAIcon name="exclamation-triangle" sameWidth={true} /><div style={{ marginLeft: "5px" }}></div></div>
            : null;
    }

    render() {
        let props: TranslationTextBoxProps = this._factory.getDefaultTranslationTextBoxProps();
        props.language = this.props.languageFieldName;
        props.translation = this.props.translationFieldName;
        props.multiLine = true;
        props.value = this.props.value;

        props.onChange = this.handleChange;

        return (<Dialog {...this.dialogProps}>
            <TranslationTextBox {...props} />
        </Dialog>

        );
    }
};